import DashboardReport from './DashboardReport';

export default DashboardReport;
